import React from "react";
import "./Footer.css";
import {
  Mail,
  Phone,
  MapPin,
  Linkedin,
  Instagram,
  Youtube,
} from "lucide-react";

import Logo from "../assets/headerLogo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid grid-3-cols">
          <div className="footer-col">
            <img src={Logo} alt="Profile" className="footer-logo" />
            <p className="footer-description">
              Consultoria estratégica especializada em clínicas e consultórios
              que desejam crescer e maximizar resultados com excelência.
            </p>
            <div className="footer-socials">
              <a
                href="https://www.linkedin.com/search/results/companies/?keywords=arcadian%20&origin=SWITCH_SEARCH_VERTICAL&sid=.gl"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <Linkedin className="icon" />
              </a>
              <a
                href="https://www.instagram.com/arcadian.co/"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <Instagram className="icon" />
              </a>
              <a
                href="https://www.youtube.com/results?search_query=arcadian"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <Youtube className="icon" />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Empresa</h4>
            <ul>
              <li>
                <a href="#about">Quem Somos</a>
              </li>
              <li>
                <a href="#services">Nossa Atuação</a>
              </li>
              <li>
                <a href="#cases">Cases</a>
              </li>
              <li>
                <a href="#faq">FAQ</a>
              </li>
              <li>
                <a href="#contact">Contato</a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contato</h4>
            <div className="footer-contact">
              <div>
                <Phone className="icon" /> <span>(77) 9 8163-1390</span>
              </div>
              <div>
                <Mail className="icon" /> <span>contato@arcadian.com.br</span>
              </div>
              <div>
                <MapPin className="icon" /> <span>Belo Horizonte, MG</span>
              </div>
            </div>
            <div className="footer-cta">
              <button className="btn-primary">
                Entre em contato conosco
              </button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {currentYear} Arcadian. Todos os direitos reservados.</span>
          <h1 className="e2tcode">
            Desenvolvido por{" "}
            <a href="https://e2tcode.com" target="_blank" rel="noreferrer">
              E2T Code
            </a>
          </h1>
          {/* <div className="footer-links">
            <a href="https://google.com" target="_blank" rel="noreferrer">
              Política de Privacidade
            </a>
            <a href="https://google.com" target="_blank" rel="noreferrer">
              Termos de Uso
            </a>
            <a href="https://google.com" target="_blank" rel="noreferrer">
              LGPD
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
